import React from 'react';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

interface BrandedLoadingProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function BrandedLoading({ className, size = 'md' }: BrandedLoadingProps) {
  const sizeClasses = {
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32',
  };

  return (
    <div className={cn('flex flex-col items-center justify-center', className)}>
      <div className={cn('relative', sizeClasses[size])}>
        <motion.div
          className="absolute inset-0"
          animate={{ rotate: 360 }}
          transition={{
            duration: 2,
            ease: "linear",
            repeat: Infinity
          }}
        >
          <div className="absolute inset-0 rounded-full border-t-4 border-primary-600 opacity-75"></div>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="absolute inset-0 flex items-center justify-center z-10"
        >
          <svg width="100%" height="100%" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="p-4">
            <path d="M50 10C27.909 10 10 27.909 10 50C10 72.091 27.909 90 50 90C72.091 90 90 72.091 90 50C90 27.909 72.091 10 50 10Z" stroke="#0284c7" strokeWidth="4" fill="none" />
            <path d="M45 40C45 37.239 47.239 35 50 35C52.761 35 55 37.239 55 40V60C55 62.761 52.761 65 50 65C47.239 65 45 62.761 45 60V40Z" fill="#0284c7" />
            <path d="M40 50C37.239 50 35 47.761 35 45C35 42.239 37.239 40 40 40H60C62.761 40 65 42.239 65 45C65 47.761 62.761 50 60 50H40Z" fill="#0284c7" />
          </svg>
        </motion.div>
      </div>
      <p className="mt-4 text-primary-600 font-medium animate-pulse">読み込み中...</p>
    </div>
  );
}